import { inject, observer } from 'mobx-react';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter, Redirect } from 'react-router-dom';

import { UserStore } from '../stores';

interface LoginProps extends RouteComponentProps {
    userStore?: UserStore;
}

@inject('userStore')
@observer
class Login extends React.Component<LoginProps> {
    render() {
        return <Redirect to="/" />;
    }
}

export default withRouter(Login);
